module.exports = __webpack_public_path__ + "img/orderRight.f19f1b85.svg";